import { useEffect, useState } from "react";

/**
 * Ejecuta una consulta del servicio y expone su resultado.
 *
 * Descarta la respuesta si el componente se desmonto o si las dependencias
 * cambiaron antes de que llegara (por ejemplo, el usuario eligio otro bloque
 * mientras cargaban los salones del anterior).
 *
 * @param {Function} consultar funcion que devuelve una Promise con el dato.
 * @param {Array} dependencias vuelven a disparar la consulta al cambiar.
 * @param {*} valorInicial que hay en `datos` antes de la respuesta y si la
 *   consulta falla: una lista vacia en los listados, null en un detalle.
 * @returns {{ datos: *, cargando: boolean, error: ?Error }} `error` es el
 *   motivo del fallo (el que manda el backend, cuando lo manda) y distingue
 *   "fallo la consulta" de "no hay datos".
 */
export const useConsulta = (consultar, dependencias = [], valorInicial = []) => {
  const [datos, setDatos] = useState(valorInicial);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let vigente = true;
    setCargando(true);
    setError(null);

    consultar()
      .then((resultado) => {
        if (!vigente) return;
        setDatos(resultado);
        setCargando(false);
      })
      .catch((fallo) => {
        if (!vigente) return;
        setDatos(valorInicial);
        setError(fallo instanceof Error ? fallo : new Error("Fallo la consulta."));
        setCargando(false);
      });

    return () => {
      vigente = false;
    };
    // `consultar` suele ser una funcion nueva en cada render; lo que decide
    // cuando repetir la consulta son las dependencias que pasa quien la usa.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencias);

  return { datos, cargando, error };
};
